module.exports = __webpack_public_path__ + "img/20.25c76d8.webp";